import axios from "axios";
import { getFileMd5 } from ".";
import { clearUserData } from "./auth";
// import alert from "./alert";
// import toast from "./toast";

const PUBLIC_URL = process.env.VUE_APP_ENV === "production" ? "/challenges" : "";

const computeUrl = (url) => {
  return url.includes("/api") ? url : PUBLIC_URL + url;
};

const handleNoAuth = () => {
  // clearToken();
  clearUserData();
  // toast("登录已过期，请重新登录");
  // alert.warning("登录已过期，请重新登录", () => {
  //   setTimeout(() => {
  //     window.location.reload();
  //   }, 300);
  // });
};

const request = {
  get(url, params, config) {
    if (params) {
      const paramsStr = Object.keys(params)
        .map((key) => `${key}=${encodeURIComponent(params[key])}`)
        .join("&");
      url = url + (url.includes("?") ? "&" : "?") + paramsStr;
    }

    return new Promise((resolve, reject) => {
      const headers = config?.headers || {};
      // const token = getToken();
      // if (token) headers["Authorization"] = `Token ${token}`;

      fetch(computeUrl(url), { ...(config || {}), headers })
        .then((response) => {
          const { status } = response;
          if (status === 401) {
            handleNoAuth();
            // return;
          }
          return response.json();
        })
        .then((data) => {
          if (data.code === -401) {
            handleNoAuth();
            // return;
          }
          return resolve(data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  post(url, data, config) {
    return new Promise((resolve, reject) => {
      const headers = { "Content-Type": "application/json", ...(config?.headers || {}) };
      // const token = getToken();
      // if (token) headers["Authorization"] = `Token ${token}`;

      fetch(computeUrl(url), {
        ...(config || {}),
        method: "POST", // or 'PUT'
        headers,
        body: JSON.stringify(data),
      })
        .then((response) => {
          const { status } = response;
          if (status === 401) {
            handleNoAuth();
            // return;
          }
          return response.json();
        })
        .then((data) => {
          if (data.code === -401) {
            handleNoAuth();
            // return;
          }
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // upload(url, data) {
  //   const formData = new FormData();
  //   Object.keys(data).forEach((key) => {
  //     formData.append(key, data[key]);
  //   });
  //   return new Promise((resolve, reject) => {
  //     fetch(computeUrl(url), {
  //       method: "POST",
  //       headers: {
  //         // "Content-Type": "multipart/form-data", // 自动设置
  //       },
  //       body: formData,
  //     })
  //       .then((response) => response.json())
  //       .then((data) => {
  //         resolve(data);
  //       })
  //       .catch((error) => {
  //         reject(error);
  //       });
  //   });
  // },
};

export default request;

// 抛出 http code 4xx/5xx 请求错误
axios.interceptors.response.use(null, (error) => {
  console.error("axios error", error);
  return Promise.reject(error);
});

export const uploadFile2CDN = async (file) => {
  try {
    const { md5Base64 } = await getFileMd5(file);
    const params = {
      bizType: "contest_camp",
      filename: file.name,
      md5Base64,
    };
    const urlRes = await request.get(computeUrl("/api/v1/upload/cos/getPresignedUrl"), params);
    if (urlRes.code !== 200) throw new Error(urlRes.msg || "上传失败");

    const { uploadUrl } = urlRes.data;
    // 该请求无返回
    await axios({
      method: "put",
      url: uploadUrl,
      data: file,
      headers: { "content-type": file.type, "Content-MD5": md5Base64 },
    });
    // console.log("upload cdn", uploadRes);
    // if (uploadRes.code !== 200) throw new Error(uploadRes.msg || "上传失败");
    return Promise.resolve(urlRes.data);
  } catch (err) {
    return Promise.reject(err);
  }
};
